import React from "react";
import { setTradeInAemShowModal } from "../../../../../../../common-deprecated/features/tradein/redux/actions/TradeInAemExternalDataActions";
import IntegratedTradeInAemAphModal from "./IntegratedTradeInAemAphModal";
import type { CarConfigDispatchType } from "../../../../redux/store";
import { useCarConfigSelector } from "../../../../redux/store";
import { showIntegratedTradeIn } from "../../../../utils/carConfigSettingsUtils";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

/**
 * The Trade-in modal should be added to the root of the Car Config component
 * The Trade-in modal can only be opened via redux dispatches.
 */
const TradeInModal = (): JSX.Element | null => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const externalData = useCarConfigSelector((state) => state.tradeInAemExternalData);
    const carConfigSettings = useCarConfigSelector((state) => state.carConfigSettings);
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const financeOption = useCarConfigSelector((state) => state.utils.financeOption);
    const financeProductName = useCarConfigSelector((state) => state.finance.info.productName);

    if (!showIntegratedTradeIn(carConfigSettings, commonSettings, financeOption, financeProductName)) return null;

    return (
        <IntegratedTradeInAemAphModal
            open={externalData.showModal}
            onRequestClose={() => dispatch(setTradeInAemShowModal(false))}
        />
    );
};

export default TradeInModal;
